import AnimatedScroll from "../../components/AnimatedScroll/AnimatedScroll";
import ContactForm from "../../components/ContactForm/ContactForm";

function Contact() {
  return (
    <section id="contact" className="contact">
      <div id="contactText" className="section-heading text-center">
        <AnimatedScroll>
          <h2>Contactez-nous 📧</h2>
        </AnimatedScroll>
      </div>
      <div className="container">
        <div className="contact-content">
          <div className="row">
            <div className="col-md-offset-1 col-md-5 col-sm-6">
              <ContactForm />
            </div>
            <div className="col-md-offset-1 col-md-5 col-sm-6">
              <div className="single-contact-box">
                <div className="contact-adress">
                  <div className="contact-add-head">
                    <AnimatedScroll>
                      <h3 className="titleLink">Dev'alls</h3>
                    </AnimatedScroll>
                    <AnimatedScroll>
                      <p>Donnez vie à vos projets d'enfer !</p>
                    </AnimatedScroll>
                  </div>
                  <div className="contact-add-info">
                    <div className="single-contact-add-info">
                      <div className="icon_title">
                        <AnimatedScroll>
                          <i
                            className="fa fa-phone logo_contact"
                            aria-hidden="true"
                          ></i>
                        </AnimatedScroll>
                        <AnimatedScroll>
                          <h3 className="titleLink">Téléphone</h3>
                        </AnimatedScroll>
                      </div>
                      <AnimatedScroll>
                        <a
                          aria-label="Number_Phone"
                          className="linkContact"
                          href="tel:+33770349718"
                        >
                          07.70.34.97.18
                        </a>
                      </AnimatedScroll>
                    </div>
                    <div className="single-contact-add-info">
                      <div className="icon_title">
                        <AnimatedScroll>
                          <i
                            className="fa fa-envelope logo_contact"
                            aria-hidden="true"
                          ></i>
                        </AnimatedScroll>
                        <AnimatedScroll>
                          <h3 className="titleLink">Email</h3>
                        </AnimatedScroll>
                      </div>
                      <AnimatedScroll>
                        <a
                          aria-label="Email"
                          className="linkContact"
                          href="mailto:contact.devalls@gmail.com"
                        >
                          contact.devalls@gmail.com
                        </a>
                      </AnimatedScroll>
                    </div>
                    <div className="single-contact-add-info">
                      <div className="icon_title">
                        <AnimatedScroll>
                          <i
                            className="fa fa-linkedin logo_contact"
                            aria-hidden="true"
                          ></i>
                        </AnimatedScroll>
                        <AnimatedScroll>
                          <h3 className="titleLink">LinkedIn</h3>
                        </AnimatedScroll>
                      </div>
                      <AnimatedScroll>
                        <a
                          aria-label="LinkedIn"
                          className="linkContact"
                          href="https://www.linkedin.com/company/106179908/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://www.linkedin.com/company/106179908/
                        </a>
                      </AnimatedScroll>
                    </div>
                    <div className="single-contact-add-info">
                      <div className="icon_title">
                        <AnimatedScroll>
                          <i
                            className="fa fa-facebook logo_contact"
                            aria-hidden="true"
                          ></i>
                        </AnimatedScroll>
                        <AnimatedScroll>
                          <h3 className="titleLink">Facebook</h3>
                        </AnimatedScroll>
                      </div>
                      <AnimatedScroll>
                        <a
                          aria-label="Facebook"
                          className="linkContact"
                          href="https://www.facebook.com/profile.php?id=61571974268200"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://www.facebook.com/profile.php?id=61571974268200
                        </a>
                      </AnimatedScroll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
